import { DATE_TIME_FORMAT } from '../../constants';
import {
  getFormattedAdminTeamFilter,
  getFormattedDateInMomentDefaultTZ,
} from '../../helpers';

export const STATE = {
  HAS_DATA: 'hasData',
  IS_DATA_LOADING: 'isDataLoading',
  IS_DATA_ERROR: 'isDataError',
};

export const getState = (isDataLoading, isDataError) => {
  if (isDataLoading) return STATE.IS_DATA_LOADING;
  if (isDataError) return STATE.IS_DATA_ERROR;
  return STATE.HAS_DATA;
};

export const getFormattedFilters = (filters, isAdmin, isManager) => ({
  ...(filters.isLifetime
    ? { startDate: null, endDate: null }
    : {
        startDate: getFormattedDateInMomentDefaultTZ(filters.startDate).format(
          DATE_TIME_FORMAT.YYYY_MM_DD_DASH,
        ),
        endDate: getFormattedDateInMomentDefaultTZ(filters.endDate).format(
          DATE_TIME_FORMAT.YYYY_MM_DD_DASH,
        ),
      }),
  ...(isAdmin && {
    adminTeam: getFormattedAdminTeamFilter(filters.callerIds),
  }),
  ...(isManager && { callerId: filters.callerId }),
});

const getDashboardContentTitle = (callerIds, teams) => {
  if (callerIds.length === 1) {
    return {
      tenantName: callerIds[0].TenantName,
      callerId: callerIds[0].CallerID,
    };
  }

  if (callerIds.length > 1) {
    const groupedCallersByTenant = callerIds.reduce((acc, v) => {
      const tenantId = v.TenantID;
      if (!acc[tenantId]) {
        acc[tenantId] = [];
      }
      acc[tenantId].push(v);
      return acc;
    }, {});
    const entries = Object.entries(groupedCallersByTenant);
    const isSelectedMoreThanOneTenant = entries.length > 1;

    if (isSelectedMoreThanOneTenant) {
      return {
        tenantName: null,
        callerId: null,
      };
    }

    if (!isSelectedMoreThanOneTenant) {
      const [key, values] = entries[0];
      const numberTenantTeam = teams.find(
        ({ TenantID }) => Number(key) === TenantID,
      ).TenantTeam.length;

      if (numberTenantTeam !== values.length) {
        return {
          tenantName: null,
          callerId: null,
        };
      } else {
        return {
          tenantName: values[0].TenantName,
          callerId: null,
        };
      }
    }
  }

  return {
    tenantName: null,
    callerId: null,
  };
};

export const getDashboardContentTenantName = (callerIds, teams) => {
  return getDashboardContentTitle(callerIds, teams).tenantName;
};

export const getDashboardContentCallerId = (callerIds, teams) => {
  return getDashboardContentTitle(callerIds, teams).callerId;
};

export const isPdfReportDisabled = (callerIds, teams) => {
  if (callerIds.length === 1) return false;

  if (callerIds.length > 1) {
    const groupedCallersByTenant = callerIds.reduce((acc, v) => {
      const tenantId = v.TenantID;
      if (!acc[tenantId]) {
        acc[tenantId] = [];
      }
      acc[tenantId].push(v);
      return acc;
    }, {});
    const entries = Object.entries(groupedCallersByTenant);
    const isSelectedMoreThanOneTenant = entries.length > 1;

    if (isSelectedMoreThanOneTenant) return true;

    if (!isSelectedMoreThanOneTenant) {
      const [key, values] = entries[0];
      const numberTenantTeam = teams.find(
        ({ TenantID }) => Number(key) === TenantID,
      ).TenantTeam.length;

      if (numberTenantTeam !== values.length) {
        return true;
      } else {
        return false;
      }
    }
  }

  return false;
};
